var map = {
	"./@astralito/book/product-page-customization-inputs/portal_Product-customization.vue": "00d6",
	"./@astralito/product-info-templates/portal_Product-adult-template.vue": "a97d",
	"./@astralito/product-info-templates/portal_Product-book-template.vue": "6f18",
	"./@astralito/product-info-templates/portal_Product-description-template.vue": "88d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1605";